import { PATH } from '#const/path';
import { ScheduleLectureState } from '#providers/SchedulesManage/SchedulesManage';
import { useNavigate } from 'react-router';

interface LectureProps {
  selectedLecture: ScheduleLectureState;
}

const Lecture = ({ selectedLecture }: LectureProps) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() =>
        navigate(`${PATH.DASHBOARD_CUSTOMER_MEMBERSHIP}/search-lecture`)
      }
      className="h-[37px] px-16 py-8 bg-[#2e2a3a] rounded-lg justify-center items-center gap-1 inline-flex"
    >
      <div className="text-[#bcb8c3] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
        {selectedLecture ? selectedLecture.lectureName : '선택'}
      </div>
    </div>
  );
};

export default Lecture;
